import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { doFetchBrands } from '../store/actions';
import { createFlagResolver, getFlagMap } from '../lib/flagResolver';
import { doSaveCurrentCardBrand } from '../store/actions';
import { getBrands } from '../store/selectors';
import defaultFlagImage from '../images/default-card.svg';

class CardFlag extends Component {
  componentDidMount() {
    this.props.onFetchBrands();
  }

  getFlagResolver = cardNumber => {
    const { brands } = this.props;

    if (Object.keys(brands).length && cardNumber) {
      const resolver = createFlagResolver(brands);
      return resolver(cardNumber);
    }
  };

  get flag() {
    const { cardNumber, className, flag } = this.props;
    const defaultFlag = { image: defaultFlagImage, name: 'Bandeira do cartão' };
    const flagMap = getFlagMap();

    const name = flag || this.getFlagResolver(cardNumber);

    this.props.onSaveCurrentCardBrand(name);

    if (!cardNumber && !flag) {
      return { className, ...defaultFlag };
    }

    return name && flagMap.has(name)
      ? { className, ...flagMap.get(name) }
      : { className, ...defaultFlag };
  }

  render() {
    const { className, image, name } = this.flag;

    return <img className={className} src={image} alt={name} />;
  }
}

CardFlag.defaultProps = {
  brand: '',
  brands: {},
  cardNumber: '',
};

CardFlag.propTypes = {
  brand: PropTypes.string,
  brands: PropTypes.object.isRequired,
  cardNumber: PropTypes.string,
  onFetchBrands: PropTypes.func.isRequired,
  onSaveCurrentCardBrand: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  brands: getBrands(state),
});

const mapDispatchToProps = dispatch => ({
  onFetchBrands: () => dispatch(doFetchBrands()),
  onSaveCurrentCardBrand: brand => dispatch(doSaveCurrentCardBrand(brand)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CardFlag);
